import { FC, HTMLAttributes } from "react";
import { useStyles } from "./AchievementCard.styles";
import { StaticImage } from "../StaticImage";
import { Typography } from "../../core/Typography/Typography";
import { ProgressBar } from "../ProgressBar";
import { TypographyVariant } from "../../../constants/typography";
import { Achievement } from "@onmo/graphql/graphql";
import { convertAchievement } from "../../../models/achievement";
import { useTranslation } from "react-i18next";

interface IAchievementCardProps {
  achievement: Achievement;
}

export const AchievementCard: FC<
  IAchievementCardProps & HTMLAttributes<HTMLDivElement>
> = ({ achievement, ...props }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { achievementName, achievementImage, progressPercentage, color } =
    convertAchievement(achievement);

  return (
    <div className={classes.root} {...props}>
      <StaticImage src={achievementImage?.src2x} className={classes.image} />
      <div className={classes.textContainer}>
        <Typography
          variant={TypographyVariant.BodyB4Bold}
          className={classes.achievementText}
          data-testid={achievementName?.split("_")[1].toLowerCase()}
        >
          {t(achievementName || "")}
        </Typography>
        <ProgressBar
          color={color}
          progress={progressPercentage}
          className={classes.progress}
        />
      </div>
    </div>
  );
};
